// -------------------------------
// ESIC REASON INTERFACES
// -------------------------------
export interface PendingEsicReason {
    reason_type?: string;
    reason_text?: string;
}

export interface PendingDeleteEsicReason {
    awaitingName?: boolean;
}

// -------------------------------
// CREATE ESIC REASON — START
// -------------------------------
export const startCreateEsicReasonFlow = (
    setPending: (data: PendingEsicReason | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    typeFromIntent?: string
) => {
    if (typeFromIntent) {
        setPending({ reason_type: typeFromIntent });

        pushAIChat("Please provide the reason text.");
        speak("Please provide the reason text.");
        return;
    }

    setPending({});
    pushAIChat("Sure! What is the reason type?");
    speak("What is the reason type?");
    window.dispatchEvent(
        new CustomEvent("ai-suggest-options", {
            detail: { type: "esic-reason-type" }
        })
    );
};

// -------------------------------
// CREATE ESIC REASON — PROCESS
// -------------------------------
export const processPendingEsicReason = (
    text: string,
    pending: PendingEsicReason,
    setPending: (data: PendingEsicReason | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — Reason Type
    if (!pending.reason_type) {
        const type = text.trim();

        if (!type) {
            pushAIChat("Please provide a valid reason type.");
            speak("Please provide a valid reason type.");
            return;
        }

        setPending({ ...pending, reason_type: type });

        pushAIChat("Please provide the reason text.");
        speak("Please provide the reason text.");
        return;
    }

    // STEP 2 — Reason Text (FINAL)
    if (!pending.reason_text) {
        const reasonText = text.trim();

        if (!reasonText) {
            pushAIChat("Please provide a valid reason text.");
            speak("Please provide a valid reason text.");
            return;
        }

        pushAIChat(`Creating ESIC reason...`);
        speak("Creating ESIC reason.");

        window.dispatchEvent(
            new CustomEvent("ai-create-esic-reason", {
                detail: {
                    reason_type: pending.reason_type,
                    reason_text: reasonText
                }
            })
        );

        setPending(null);
        return;
    }
};

// -------------------------------
// DELETE ESIC REASON — START
// -------------------------------
export const startDeleteEsicReasonFlow = (
    setPendingDelete: (data: PendingDeleteEsicReason | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting ESIC reason "${nameFromIntent}"...`);
        speak(`Deleting ESIC reason ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-esic-reason", {
                detail: { text: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which ESIC reason would you like to delete?");
    speak("Which ESIC reason would you like to delete?");
};

// -------------------------------
// DELETE ESIC REASON — PROCESS
// -------------------------------
export const processPendingDeleteEsicReason = (
    text: string,
    pending: PendingDeleteEsicReason,
    setPendingDelete: (data: PendingDeleteEsicReason | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanText = text.trim();

    if (!cleanText) {
        pushAIChat("Please provide a valid reason text.");
        speak("Please provide a valid reason text.");
        return;
    }

    pushAIChat(`Deleting ESIC reason "${cleanText}"...`);
    speak(`Deleting ESIC reason ${cleanText}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-esic-reason", {
            detail: { text: cleanText }
        })
    );

    setPendingDelete(null);
};